<template>
    <div v-if="_header">
        <h5>Bitte warten</h5>
        <h3>Daten werden geladen&hellip;</h3>
    </div>

    <content-placeholders v-else>
        <content-placeholders-heading :img="true" />
        <content-placeholders-text :lines="3" />
    </content-placeholders>
</template>

<script>
export default {
  props: ['_header'],
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/view-stack/components/loading.vue